module.exports = __webpack_public_path__ + "static/media/restart.bfcfd28f.ico";